import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "../../lib/api";

const blank = { current: "", next: "", confirm: "" };

export const ChangePassword = ({ onDone }) => {
  const [f, setF] = useState(blank);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const on = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 8) return setError("New password must be at least 8 characters.");
    if (f.next !== f.confirm) return setError("The new passwords don't match.");
    setBusy(true);
    try {
      await http.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password changed. Use your new password next time you sign in.");
      setF(blank);
      onDone();
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const input = (k, label, auto) => (
    <label className="block">
      <span className="mb-2 block font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--sage)]">{label}</span>
      <input type="password" value={f[k]} onChange={on(k)} required autoComplete={auto} className="field" data-testid={`password-input-${k}`} />
    </label>
  );

  return (
    <form onSubmit={submit} className="mt-8 grid max-w-md gap-5 rounded-3xl border border-white/10 bg-[#161D17] p-6 sm:p-8" data-testid="change-password-form">
      {input("current", "Current password", "current-password")}
      {input("next", "New password (8+ characters)", "new-password")}
      {input("confirm", "Confirm new password", "new-password")}
      {error && <p className="text-sm text-[#F2A08C]" data-testid="change-password-error">{error}</p>}
      <button disabled={busy} className="btn-gold justify-center py-3.5" data-testid="change-password-submit">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Change password"}
      </button>
    </form>
  );
};
